import { render, staticRenderFns } from "./BottomTable.vue?vue&type=template&id=0a2faa17&scoped=true"
import script from "./BottomTable.vue?vue&type=script&lang=ts"
export * from "./BottomTable.vue?vue&type=script&lang=ts"
import style0 from "./BottomTable.vue?vue&type=style&index=0&id=0a2faa17&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2faa17",
  null
  
)

export default component.exports